import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "@sentry/react";
import { PrimeReactProvider } from "primereact/api";
import "./index.css";
import App from "./App";
import ErrorFallback from "./components/ErrorFallback";
import { initSentry } from "./utils/sentry";
import { initStaleBuildHandling } from "./utils/staleBuild";
import "./styles/primereact-theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import reportWebVitals from "./reportWebVitals";

initSentry();
initStaleBuildHandling();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={({ error }) => <ErrorFallback error={error} />}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
